<div class="modal-container">
  <div class="modal-header border-0 justify-content-between gap-5">
        <h1 class="modal-title text-center text-primary-color text-nowrap">{{ insertUpdateCodeCrosswalk.id ? this.enumPopUpTitles.EDIT : this.enumPopUpTitles.ADD }} Code Group</h1>
        <div class="hand d-flex align-items-center gap-0 gap-md-4">
            <div class="">
                <app-switch class="" 
                [status]="insertUpdateCodeCrosswalk.active"
                (click)="toggleActive()"
                ></app-switch>
            </div>
            <div (click)="clearDetails()" class="hand d-flex align-items-center ps-2">
                    <app-svg
                      iconType="Clear"
                      class="h-33px">
                    </app-svg>
                  
                  <span class="px-2 pe-0 clear-color font-14">Clear Details</span>
              </div>
        </div>
  </div>
  <div class="modal-body">
    <div class="container p-0">
      <div class="row gap-3 mb-4 mx-0">
        <div class="col-12 col-sm-6 text-center px-0">
          <app-input 
              onlyNumbers 
              [inputLabel]="'SIC Code'" 
              [inputType]="'text'" 
              [inputValue]="insertUpdateCodeCrosswalk.sic"
              (inputValueEmit)="insertUpdateCodeCrosswalk.sic=$event;onSicInputChange($event);clearValue(insertUpdateCodeCrosswalk.sic, 'sic')"
               [ngClass]="{'border-red': !insertUpdateCodeCrosswalk.sic && submit }" 
               (focusout)="onSicInputBlur()"
               [inputMaxlength]="8"
              [inputReqValidation]="true">
          </app-input>
          <div *ngIf="isSicError" class="error-text">SIC Code must be at least 4 characters.</div>
        </div>
        <div class="col text-center px-0">
          <app-textarea 
          [label]="'SIC Description'"
          [textareaHeight]="'7.2rem'"
          [name]="'SICDescription'"
          [id]="'SICDescription'"
          [isRequired]="true"
          [inputValue]="insertUpdateCodeCrosswalk.sicDescription"
          (inputValueEmit)="insertUpdateCodeCrosswalk.sicDescription=$event"
          [textareaClass]="{'bordered-red': !insertUpdateCodeCrosswalk.sicDescription && submit }" 
          ></app-textarea>
        </div>
      </div>
      <hr class="m-0">
      <div class="row gap-3 my-4 mx-0">
        <div class="col-12 col-sm-6 left-column-size">
          <div class="col text-center px-0">
            <app-input 
                onlyNumbers 
                [inputLabel]="'NAICS Code'" 
                [inputType]="'text'" 
                [inputValue]="insertUpdateCodeCrosswalk.naics"
                [inputMaxlength]="4"
                (inputValueEmit)="insertUpdateCodeCrosswalk.naics=$event;onNaicsInputChange($event);clearValue(insertUpdateCodeCrosswalk.naics, 'naics')"
                [ngClass]="{'border-red':!insertUpdateCodeCrosswalk.naics && submit }" 
                (focusout)="onNaicsInputBlur()"
                [inputReqValidation]="true">
            </app-input>
            <div *ngIf="isNaicsError" class="error-text">NAICS Code must be at least 4 characters.</div>
          </div>
          <div class="col text-center px-0 d-flex align-items-end">
            <app-input 
              class="w-100"
                onlyNumbers 
                [inputLabel]="'NAICS Year'"     
                [inputType]="'text'" 
                [inputReqValidation]="true"
                [inputMaxlength]="4"
                [inputValue]="insertUpdateCodeCrosswalk.naicsYear"
                (inputValueEmit)="insertUpdateCodeCrosswalk.naicsYear=$event;onYearInputChange($event);clearValue(insertUpdateCodeCrosswalk.naicsYear, 'naicsYear')"
                (focusout)="onYearInputBlur()"
                [ngClass]="{'border-red': !insertUpdateCodeCrosswalk.naicsYear && submit }" 
                >
            </app-input>
            <div *ngIf="isYearError" class="error-text">NAICS Year must be at least 4 characters.</div>
          </div>
        </div>
        <div class="col text-center px-0">
            <app-textarea 
            [label]="'NAICS Description'"
            [textareaHeight]="'7.2rem'"
            [name]="'notes'"
            [id]="'notes'"
            [isRequired]="true"
            [inputValue]="insertUpdateCodeCrosswalk.naicsDescription"
            (inputValueEmit)="insertUpdateCodeCrosswalk.naicsDescription=$event"
            [textareaClass]="{'bordered-red': !insertUpdateCodeCrosswalk.naicsDescription && submit }" 
            ></app-textarea>
        </div>
      </div>
      <hr class="m-0">
      <div class="row gap-3 mt-4 mx-0">
                <div class="col px-0 mx-0">
                    <div class="col text-center px-0">
                        <app-input 
                            onlyAlphabets 
                            [inputLabel]="'Industry'" 
                            [inputType]="'text'" 
                            [inputValue]="insertUpdateCodeCrosswalk.industry"
                            (inputValueEmit)="insertUpdateCodeCrosswalk.industry=$event"
                            [ngClass]="{'border-red': !insertUpdateCodeCrosswalk.industry && submit }" 
                            [inputReqValidation]="true">
                        </app-input>
                    </div>
                </div>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-end">
        <div class="m-0 d-flex gap-3">
          <app-button class="" [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button '" (click)="activeModal.close()" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button class="" [buttonType]="'submit'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" (click)="insertUpdateCodeCrosswalk.id ?addCodeGroup(enumButtonName.UPDATE):addCodeGroup(enumButtonName.SAVE)" [buttonLable]="insertUpdateCodeCrosswalk.id ? enumButtonName.UPDATE : enumButtonName.SAVE"></app-button>
          <app-button class="" [buttonType]="'submit'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" (click)="insertUpdateCodeCrosswalk.id ?addCodeGroup(enumButtonName.UPDATE):addCodeGroup(enumButtonName.SAVE);addNew = !addNew" [buttonLable]="insertUpdateCodeCrosswalk.id ? enumButtonName.UPDATEANDADDNEW : enumButtonName.SAVEANDADDNEW"></app-button>
        </div>
  </div>
</div>
